import { useState } from "react";
import { useDispatch } from "react-redux";
import searchImage from "../assets/images/search.svg";
import { generalsearch } from "../redux/blog/actions";


const Search = () => {
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState("");
    const [timer, setTimer] = useState(null);

    const debounce = (cb, delay) => {
        return function(...args) {
            if(timer) {
                clearTimeout(timer);
                setTimer(null);
            }
            const timerId = setTimeout(() => cb(...args), delay);
            setTimer(timerId);
        };
    };

    const callDebouncer = debounce(text => {
        dispatch(generalsearch(text));
    }, 1000);

    const handleSearchText = (e) => {
        const value = e.target.value;
        setSearchText(value);
        callDebouncer(value);
    };

    return (
        <div
            className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200"
        >
            <input
                className="outline-none border-none bg-gray-50 h-full w-full mr-2"
                type="search"
                name="search"
                placeholder="Search"
                value = {searchText}
                onChange = {handleSearchText}
            />
            <img
                className="inline h-6 cursor-pointer"
                src={searchImage}
                alt="Search"
            />
        </div>
    );
};

export default Search;